<template>
    <div
      class="slider"
      @touchmove="touchHandler($event)"
      @touchend="touchStopHandler($event)"
    >
      <div class="touch-target" />
      <div class="thin-bar" />
      <div class="thick-bar" />
    </div>
  </template>
  
  <script>
  global.jQuery = require('jquery');
  const $ = global.jQuery;
  require('webpack-jquery-ui/draggable');
  require('webpack-jquery-ui/droppable');
  
  export default {
      props: ['sliderId', 'chartPosition'],
      mounted() {
          $(this.$el).draggable({ axis: 'x', containment: '.nav-container', scroll: false });
          $(this.$el).on('drag', this.dragHandler);
          $(this.$el).on('dragstop', this.dragStopHandler);
      },
      methods: {
          dragHandler(e) {
              const dragData = {
                  dragPosition: e.clientX - 0, //navleft
                  sliderId: this.sliderId
              };
              this.$emit('update-drag', dragData);
          },
          dragStopHandler(e) {
              this.$emit('update-chart');
          },
          touchHandler(e) {
              if (e.touches && e.touches.length) {
                  const touchData = {
                      dragPosition: e.touches[e.touches.length - 1].clientX - 0, //navleft
                      sliderId: this.sliderId
                  };
                  this.$emit('update-drag', touchData);
              }
          },
          touchStopHandler(e) {
              this.$emit('update-chart');
          }
      }
  };
  </script>
  
  <style lang="less">
      .slider {
          cursor: pointer;
          position: absolute;
          z-index: 1;
          .thick-bar {
              background-color: #009ADF;
              border-radius: 3px;
              height: 60%;
              position: absolute;
              top: 20%;
              left: -3px;
              width: 6px;
          }
          .thin-bar {
              background-color: #009ADF;
              height: 100%;
              position: absolute;
              top: 1px;
              width: 1px;
          }
          .touch-target {
              position: absolute;
              left: -25px;
              width: 50px;
          }
      }
  </style>
  